// app/types/api.ts - 全局 API 类型与错误定义

// ==================== 请求/响应公共结构 ====================

/** 请求公共字段（与后端 common.proto 对应） */
export interface Common {
  uid?: string
  token?: string
  app_id: string
  request_id?: string
  channel: string
  version: string
  device_id?: string
  platform: string
  lang: string
  payload?: Record<string, string>
}

/** 响应公共字段 */
export interface RespCommon {
  ret: number
  msg: string
  request_id: string
  cfg_version: number
}

/** 完整响应结构 */
export interface ApiResponse<T = any> {
  resp_common: RespCommon
  data?: T
}

// ==================== 错误相关 ====================

/** API 错误类型枚举 */
export enum ApiErrorType {
  NETWORK = 'NETWORK',
  HTTP = 'HTTP',
  BUSINESS = 'BUSINESS',
  LOGIN_EXPIRED = 'LOGIN_EXPIRED',
  UNKNOWN = 'UNKNOWN'
}

/** API 错误类 */
export class ApiError extends Error {
  type: ApiErrorType
  code?: number
  requestId?: string
  originalError?: any

  constructor(
    type: ApiErrorType,
    message: string,
    code?: number,
    requestId?: string,
    originalError?: any
  ) {
    super(message)
    this.type = type
    this.code = code
    this.requestId = requestId
    this.originalError = originalError
    this.name = 'ApiError'
  }

  isLoginExpired(): boolean {
    return this.type === ApiErrorType.LOGIN_EXPIRED
  }

  isNetworkError(): boolean {
    return this.type === ApiErrorType.NETWORK
  }
}

// ==================== 签名请求头 ====================
export interface SignatureHeaders {
  Authorization: string
  'Content-MD5': string
  Accept: string
  'Content-Type': string
  Date: string
  'x-cds-signature-nonce': string
}

// ==================== API 配置 ====================
export interface ApiConfig {
  baseURL: string
  timeout: number
  appId: string
  accessKey: string
  accessSecret: string
  channel: string
  version: string
  platform: string
  lang: string
}

